export default function Privacidade() {
  return (
    <div className="bg-dark-900 min-h-screen">
      {/* Background Effects */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-neon-blue/20 rounded-full blur-[120px] animate-pulse-slow"></div>
        <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-neon-purple/20 rounded-full blur-[120px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="relative z-10">
        {/* Header */}
        <header className="border-b border-neon-blue/20 bg-dark-800/60 backdrop-blur-xl">
          <div className="container mx-auto px-4 md:px-6 py-6">
            <div className="flex items-center justify-between">
              <a href="/" className="text-2xl md:text-3xl font-black bg-gradient-to-r from-neon-blue to-neon-purple bg-clip-text text-transparent cursor-pointer">
                Freedom Experience
              </a>
              <a 
                href="/"
                className="flex items-center gap-2 text-gray-400 hover:text-neon-blue transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
                <span className="text-sm md:text-base">Voltar</span>
              </a>
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="container mx-auto px-4 md:px-6 py-12 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="bg-dark-800/60 backdrop-blur-xl border border-neon-blue/30 rounded-2xl md:rounded-3xl p-6 md:p-10 lg:p-12">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 md:mb-8">
                Política de Privacidade
              </h1>

              <div className="space-y-6 md:space-y-8 text-gray-300">
                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">1. Introdução</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    O Freedom Experience respeita sua privacidade e está comprometido em proteger seus dados pessoais. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">2. Informações que Coletamos</h2>
                  <p className="text-sm md:text-base leading-relaxed mb-3">
                    Coletamos as seguintes informações quando você se inscreve no curso:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm md:text-base">
                    <li>Nome completo do aluno e responsável</li>
                    <li>Data de nascimento do aluno</li>
                    <li>Email e telefone de contato</li>
                    <li>Endereço residencial</li>
                    <li>Informações de pagamento (processadas por terceiros seguros)</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">3. Como Usamos suas Informações</h2>
                  <p className="text-sm md:text-base leading-relaxed mb-3">
                    Utilizamos seus dados para:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm md:text-base">
                    <li>Processar sua inscrição e matrícula</li>
                    <li>Comunicar informações sobre o curso</li>
                    <li>Enviar materiais didáticos e recursos</li>
                    <li>Melhorar nossos serviços educacionais</li>
                    <li>Cumprir obrigações legais</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">4. Proteção de Dados de Menores</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Como trabalhamos com jovens de 8 a 17 anos, tomamos cuidados especiais com a proteção de dados de menores. Todas as inscrições devem ser realizadas por um responsável legal, e coletamos apenas as informações estritamente necessárias para a prestação do serviço educacional.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">5. Compartilhamento de Informações</h2>
                  <p className="text-sm md:text-base leading-relaxed mb-3">
                    Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm md:text-base">
                    <li>Quando necessário para processar pagamentos</li>
                    <li>Para cumprir obrigações legais</li>
                    <li>Com seu consentimento explícito</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">6. Segurança dos Dados</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Implementamos medidas de segurança técnicas e organizacionais para proteger seus dados contra acesso não autorizado, alteração, divulgação ou destruição. Isso inclui criptografia, controles de acesso e armazenamento seguro.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">7. Seus Direitos</h2>
                  <p className="text-sm md:text-base leading-relaxed mb-3">
                    De acordo com a LGPD (Lei Geral de Proteção de Dados), você tem direito a:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-sm md:text-base">
                    <li>Acessar seus dados pessoais</li>
                    <li>Corrigir dados incompletos ou desatualizados</li>
                    <li>Solicitar a exclusão de seus dados</li>
                    <li>Revogar consentimento a qualquer momento</li>
                    <li>Solicitar portabilidade dos dados</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">8. Cookies e Tecnologias Similares</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Nosso site pode usar cookies para melhorar sua experiência de navegação. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar algumas funcionalidades do site.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">9. Retenção de Dados</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Mantemos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades descritas nesta política, ou conforme exigido por lei.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">10. Alterações nesta Política</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre mudanças significativas através do email cadastrado.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">11. Contato</h2>
                  <p className="text-sm md:text-base leading-relaxed">
                    Para exercer seus direitos ou esclarecer dúvidas sobre esta Política de Privacidade, entre em contato através do email: <a href="mailto:z@zulk.com.br" className="text-neon-blue hover:text-neon-purple transition-colors duration-300">z@zulk.com.br</a>
                  </p>
                </section>

                <div className="pt-6 md:pt-8 border-t border-neon-blue/20">
                  <p className="text-xs md:text-sm text-gray-400">
                    Última atualização: Dezembro de 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
